module.exports = __webpack_public_path__ + "static/individual-support-room1-f56801f4657fc585dc3dd684b9f5d99d.png";